/* eslint-disable no-negated-condition */
import {
  Column,
  Columns,
  Heading,
  HeadingProps,
} from "@origin-digital/ods-core";
import React from "react";
import styled from "styled-components";
import { ActionBarMobileProps, getMobileNavButton } from "./ActionBarMobile";
import { Box } from "./Box";
import { HelpSupportButton } from "./HelpSupportButton";

const CustomHeading = ({
  className,
  children,
  component,
  "data-id": dataId,
}: HeadingProps) => (
  <Heading
    variant="h4"
    className={className}
    component={component}
    data-id={dataId}
  >
    {children}
  </Heading>
);

const StyledCustomHeading = styled(CustomHeading)`
  && {
    font-size: ${({ theme }) => `${theme.typography.body1.fontSize}`};
  }
`;

const ButtonContainer = styled(Box)<{ isDesktop: boolean }>`
  display: flex;
  width: ${({ isDesktop }) => (isDesktop ? "auto" : "44px")};
  height: 44px;
`;

export const NavTitle = ({
  mobileNavButton,
  onClickMobileNavButton,
  headingComponent,
  title,
  desktopVariant,
  isDesktop,
  showPropertySelector,
  propertySelector,
  onClickHelpSupportButton,
  secondaryColor,
}: ActionBarMobileProps) => {
  return (
    <Box width="full">
      <Columns space="none" alignY="center">
        {!isDesktop || desktopVariant === "slim" ? (
          <>
            <Column width={!isDesktop ? "content" : "flex"}>
              {!showPropertySelector && (
                <ButtonContainer
                  isDesktop={isDesktop}
                  justifyContent="flex-start"
                >
                  {getMobileNavButton(
                    mobileNavButton,
                    onClickMobileNavButton,
                    isDesktop,
                    desktopVariant,
                    showPropertySelector
                  )}
                </ButtonContainer>
              )}
            </Column>
            <Column alignX="center">
              {showPropertySelector ? (
                <Box display="flex" justifyContent="flex-start" width="full">
                  {propertySelector}
                </Box>
              ) : title ? (
                <StyledCustomHeading
                  data-id="actionbar-heading-mobile"
                  variant="h4"
                  component={headingComponent}
                >
                  {title}
                </StyledCustomHeading>
              ) : null}
            </Column>
          </>
        ) : null}

        <Column width={!isDesktop ? "content" : "flex"} alignX="right">
          <Box
            display="flex"
            justifyContent="flex-end"
            style={{ height: "44px" }}
          >
            {onClickHelpSupportButton && (
              <HelpSupportButton
                onClick={onClickHelpSupportButton}
                secondaryColor={secondaryColor}
              />
            )}
            {/* placeholder to keep the layout balanced */}
          </Box>
        </Column>
      </Columns>
    </Box>
  );
};
